// extracted by mini-css-extract-plugin
export default {"itemContainer":"styles_itemContainer__--6oQ","item":"styles_item__gNwrW"};